<template>
  <div>
    <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'订单审批'}]" v-if="this.taskstatus == '0'"/>
    <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'订单详情'}]" v-if="this.taskstatus == '1'"/>


    <!---------------------------------------------------项目信息-------------------------------------------------------------------->
    <div class="h-piece ddform_disable_cls" style="margin:20px">
      <div class="h-pieceIn2 n-xiao" v-if="order.orderProjectCode">
        <div class="h-pieceTitle2 " style="margin-left:10px">
          <h1>项目信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine">
            <el-form :model="order" label-position="right" :inline="true"
                     class="demo-ruleForm h-formbLine">
              <el-form-item label="项目名称" class="h-elformWrap-2">
                <el-input v-model="order.orderProjectName" readonly></el-input>
              </el-form-item>
              <el-form-item label="项目合同编号" class="h-elformWrap-2">
                <el-input v-model="order.orderSubContract" readonly></el-input>
              </el-form-item>
              <el-form-item label="报价单" class="h-elformWrap-2">
                <brupload
                    :refid=order.orderProjectCode
                    reftype = "外销项目-PO"
                    :limit="1"
                    :showtime="false"
                >
                </brupload>
              </el-form-item>
              <el-form-item label="PO凭证" class="h-elformWrap-2">
                <brupload
                    :refid=order.orderProjectCode
                    reftype="外销项目-PI"
                    :limit="1"
                    :showtime="false"
                >
                </brupload>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------项目信息-------------------------------------------------------------------->
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>订单信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form label-position="right" :inline="true"
                     class="demo-ruleForm h-formbLine">
              <el-form-item label="订单类型" class="h-elformWrap-2">
                <el-input v-model="xsqyStr" readonly :show-overflow-tooltip="true"></el-input>
              </el-form-item>
              <el-form-item label="订单编码" class="h-elformWrap-2">
                <el-input v-model="this.order.sapCode" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建人" class="h-elformWrap-2">
                <el-input v-model="this.order.cuname" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建时间" class="h-elformWrap-2">
                <el-input v-model="this.order.cdate" readonly></el-input>
              </el-form-item>
              <el-form-item label="销售组织" class="h-elformWrap-2">
                <el-input v-model="xszzStr" readonly></el-input>
              </el-form-item>
              <el-form-item label="分销渠道" class="h-elformWrap-2">
                <el-input v-model="fxqdStr" readonly></el-input>
              </el-form-item>
              <el-form-item label="成本中心" class="h-elformWrap-2" v-if="showIsFree || showIsFree6200">
                <el-select v-model="order.costCenter"  style="width: 100%;" disabled>
                  <el-option v-for="item in costList" :key="item.index"
                             :label="`${item.costCenterCode} : ${item.remark}`" :value="item.costCenterCode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订购原因" class="h-elformWrap-2" v-if="showIsFree || showIsFree6200">
                <brselect clearable category="business_reason" :v="order.businessReason"
                          v-model="order.businessReason" disabled></brselect>
              </el-form-item>
              <!--
              <el-form-item label="备注" class="h-elformWrap-2">
                  <el-input v-model="this.order.note" readonly></el-input>
              </el-form-item>
              -->
              <el-form-item label="报价单" class="h-elformWrap-2">
                <brupload
                    :refid=order.id
                    reftype="订单-外销项目-PI"
                    :limit="1"
                    :showtime="false"
                >
                </brupload>
              </el-form-item>
              <el-form-item label="PO凭证" class="h-elformWrap-2">
                <brupload
                    :refid=order.id
                    reftype="订单-外销项目-PO"
                    :limit="1"
                    :showtime="false"
                >
                </brupload>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>客户信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form :model="order" ref="form1" label-position="right" :inline="true"
                     class="demo-ruleForm h-formbLine">
              <el-form-item prop="soldToName" label="售达方名称" class="h-elformWrap-2">
                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                </el-input>
              </el-form-item>

              <el-form-item prop="soldToAreaName" label="售达方区域"    class="h-elformWrap-2">
                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
              </el-form-item>
              <el-form-item prop="shipToAreaCode" label="送达方区域"   :rules="[
								  { required: true, message: '售达方区域不能为空', trigger: 'change'},
								]" class="h-elformWrap-2">
                <brselectlazy category="YLCountry_agent" disabled
                              :showcode="true"
                              v-model="order.shipToAreaCode" :v="order.shipToAreaCode"
                ></brselectlazy>
              </el-form-item>
              <!--  <el-form-item prop="shipToAreaCode" label="区域" v-if="disabled"  :rules="[
                      { required: true, message: '区域不能为空', trigger: 'change'},
                    ]" class="h-elformWrap-2">
                    <el-select v-model="order.businessArea" :v="order.businessArea" disabled filterable placeholder="请选择" style="width:100%" @change="getAreaUserList">
                        <el-option v-for="(item,index) in areaList"
                                   :key="index" :label="`[${item.qycode}]${item.qyname}`" :value="item.qycode"></el-option>
                    </el-select>
                </el-form-item>-->
              <el-form-item prop="shipToAreaCode" label="业务主人" v-if="disabled"  :rules="[
								  { required: true, message: '业务主人不能为空', trigger: 'change'},
								]" class="h-elformWrap-2">
                <el-select v-model="order.businessUser" :v="order.businessUser" disabled filterable placeholder="请选择" style="width:100%">
                  <el-option v-for="(item,index) in areaUserList"
                             :key="index" :label="`[${item.usercode}]${item.username}`" :value="item.usercode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="toCompanyname" label="港口"   class="h-elformWrap-2">
                <el-input v-model="order.toCompanyname" readonly></el-input>
              </el-form-item>
              <el-form-item prop="gjmytk" label="国际贸易条款"  class="h-elformWrap-2"  >
                <mdmselect clearable category="YlCommercialTerms" disabled :v="order.gjmytk"
                           :showcode="true"
                           v-model="order.gjmytk"></mdmselect>
              </el-form-item>
              <el-form-item prop="fktj" label="付款条件"    class="h-elformWrap-2">
                <brselect clearable category="DD_FKTJ" disabled :v="order.fktj" :showcode="true"
                          v-model="order.fktj"></brselect>
              </el-form-item>
              <el-form-item prop="fktj" label="上传信用证" v-if="shifouxinyzh" class="h-elformWrap-2">
                <brupload
                    :refid=order.id
                    reftype="订单-外销项目-信用证"
                    :limit="1"
                    :showtime="false"
                >
                </brupload>
              </el-form-item>
              <el-form-item prop="currencyCode" label="币种"   class="h-elformWrap-2">
                <mdmselect clearable category="YLCurrency"
                           :v="order.currencyCode"
                           :showcode="true"
                           disabled
                           v-model="order.currencyCode"></mdmselect>
              </el-form-item>

              <el-form-item prop="kucun" label="库位" class="h-elformWrap-2">
                <brselect clearable category="order_wx_kuwei"
                          :v="order.kucun"
                          disabled
                          v-model="order.kucun"></brselect>
              </el-form-item>
              <el-form-item prop="boxing" label="装箱方式" class="h-elformWrap-2">
                <brselect clearable category="zhuangxiang"
                          :v="order.boxing"
                          disabled
                          v-model="order.boxing"></brselect>
              </el-form-item>
              <el-form-item prop="attachment" label="是否有备件" class="h-elformWrap-2">
                <brselect clearable category="shifou_keyong"
                          :v="order.attachment"
                          disabled
                          v-model="order.attachment"></brselect>
              </el-form-item>
              <el-form-item label="船期日期" class="h-elformWrap-2">
                <el-date-picker v-model="order.shipDate" type="date" disabled=""
                                class="h-tableInput" :clearable="false"
                                :picker-options="pickerOptions"
                                placeholder="请选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item v-if="isAddress" prop="toAddress" label="收货地址" class="h-elformWrap-2">
                <el-input v-model="order.toAddress" placeholder="请输入" disabled></el-input>
              </el-form-item>
              <el-form-item v-if="isAddress" prop="toAddress" label="收货联系人" class="h-elformWrap-2">
                <el-input v-model="order.contactName" placeholder="请输入" disabled></el-input>
              </el-form-item>
              <el-form-item v-if="isAddress" prop="toAddress" label="联系方式" class="h-elformWrap-2">
                <el-input v-model="order.firsttelephone" placeholder="请输入" disabled></el-input>
              </el-form-item>
              <el-form-item v-if="isAddress" prop="toCompany" label="收货单位" class="h-elformWrap-2">
                <el-input v-model="order.toCompany" placeholder="请输入" disabled></el-input>
              </el-form-item>
              <el-form-item prop="overseaShname" label="境外收货人"  class="h-elformWrap-2">
                <el-input v-model="order.overseaShname" readonly placeholder="请输入"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
      <div class="h-table h-mrt30 " style="margin: 10px ">
        <div class="h-pieceTitle2 message">
          <h1>产品信息</h1>
        </div>
        <el-table
            ref="multipleTable"
            :data="productlist1"
            stripe
            border
            style="width: 100%">
          <el-table-column
              type="index"
              label="#"
              width="40">
          </el-table-column>
          <el-table-column
              prop="proModelName"
              label="产品大类"
              :show-overflow-tooltip="true"
              min-width="100">
          </el-table-column>
          <el-table-column
              prop="materialCode"
              label="产品编码"
              min-width="120">
          </el-table-column>
          <el-table-column
              prop="materialName"
              label="产品名称"
              min-width="180"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.materialName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="oemDesc"
              label="规格型号"
              min-width="180"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.oemDesc}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="proBenchmarkPrice"
              label="基准价"
              min-width="110">
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.proBenchmarkPrice}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="currencyCode"
              label="币种"
              min-width="90">
          </el-table-column>
          <el-table-column
              v-if="tejieshowflag"
              prop="specialPrice"
              label="特价"
              min-width="120"
          >
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.specialPrice}}
              </div>
            </template>
          </el-table-column>
          <!--<el-table-column-->
          <!--v-if="tejieshowflag"-->
          <!--prop="specialPriceNum"-->
          <!--label="特价余量"-->
          <!--min-width="110">-->
          <!--</el-table-column>-->
          <el-table-column
              prop="feeyongj"
              label="佣金/单台"
              min-width="110">
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.feeyongj}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="feebaof"
              label="保费/单台"
              min-width="110" v-if="!showService && showFee">
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.feebaof}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="feeyunf"
              label="运费/单台"
              min-width="110" v-if="!showService && showFee">
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.feeyunf}}
              </div>
            </template>
          </el-table-column>

          <el-table-column
              v-if="dingzhishowflag"
              prop="extraDes"
              label="改制需求"
              :show-overflow-tooltip="true"
              min-width="250">
            <template slot-scope="scope">
              <p style="text-align: left" v-html='scope.row.extraDes'></p>
            </template>
          </el-table-column>

          <el-table-column
              v-if="dingzhishowflag"
              prop="extraPrice"
              label="改制加价"
              min-width="110" >
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.extraPrice}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="proNumber"
              label="数量"
              min-width="120">
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.proNumber}}
              </div>
            </template>
          </el-table-column>

          <el-table-column
              prop="wlmaozh"
              :label="`毛重/${dwzhiliang}`"
              min-width="90"
              :show-overflow-tooltip="true" v-if="!showService">
            <template slot-scope="scope">
              <div style="text-align: right">{{ scope.row.hjmaozh.toFixed(3)}}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="wljinzh"
              :label="`净重/${dwzhiliang}`"
              min-width="90"
              :show-overflow-tooltip="true" v-if="!showService">
            <template slot-scope="scope">
              <div style="text-align: right">{{ scope.row.hjjinzh.toFixed(3) }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="wltiji"
              :label="`体积/${dwtiji}`"
              min-width="100"
              :show-overflow-tooltip="true" v-if="!showService">
            <template slot-scope="scope">
              <div style="text-align: right">{{ scope.row.hjtiji.toFixed(3)}}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="measure"
              label="尺寸(长宽高)"
              min-width="120"
              :show-overflow-tooltip="true" >
            <template slot-scope="scope">
              {{ scope.row.measure }}
            </template>
          </el-table-column>

          <el-table-column
              prop="expoPrice"
              label="销售单价"
              min-width="100" >
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.expoPrice}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="finalPrice"
              label="成交价"
              min-width="100">
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.finalPrice}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="totalprice"
              label="总价"
              min-width="100"
          >
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.totalprice}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="note1"
              label="备注"
              :show-overflow-tooltip="true"
              width="110"
          >
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.note1}}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="jieguo" v-if="!showIsFree">

          <span class="jieguo_label">订单总价</span>
          <span class="jieguo_value">{{ order.orderPrice }}</span>

          <span class="jieguo_label">RMB总价</span>
          <span class="jieguo_value">{{ order.orderPriceRbm }}</span>

          <span class="jieguo_label">净价值</span>
          <span class="jieguo_value">{{ order.orderNetWorth }}</span>

          <span class="jieguo_label" style="background: transparent;"></span>
          <span class="jieguo_value"></span>
          <span class="jieguo_label" style="background: transparent;"></span>
          <span class="jieguo_value"></span>
        </div>
        <div class="jieguo" v-if="!showIsFree && !showService">
          <span class="jieguo_label">总件数</span>
          <span class="jieguo_value">{{ order.allNum }}</span>
          <span class="jieguo_label">毛重汇总/{{this.dwzhiliang}}</span>
          <span class="jieguo_value">{{ order.allhjmaozh }}</span>
          <span class="jieguo_label">净重汇总/{{this.dwzhiliang}}</span>
          <span class="jieguo_value">{{(order.allhjjinzh )}}</span>
          <span class="jieguo_label">体积汇总/{{this.dwtiji}}</span>
          <span class="jieguo_value">{{order.allhjtiji }}</span>
          <span class="jieguo_label" style="background: transparent;"></span>
          <span class="jieguo_value"></span>
        </div>

        <div class="jieguo" v-if="!showIsFree">
          <span class="jieguo_label">总佣金合计</span>
          <span class="jieguo_value">{{ order.allfeeyongj }}</span>
          <span class="jieguo_label" v-if="!showService && showFee">总保费合计</span>
          <span class="jieguo_value" v-if="!showService && showFee">{{(order.allfeebaof)}}</span>
          <span class="jieguo_label" v-if="!showService && showFee">总运费合计</span>
          <span class="jieguo_value" v-if="!showService && showFee">{{order.allfeeyunf }}</span>
          <span class="jieguo_label" style="background: transparent;"></span>
          <span class="jieguo_value"></span>
          <span class="jieguo_label" style="background: transparent;"></span>
          <span class="jieguo_value"></span>
        </div>

      </div>
      <div class="h-table h-mrt30 " style="margin: 10px " v-if="otherTable.length > 0">
        <div class="h-pieceTitle2 message">
          <h1>被占用预测单信息</h1>
        </div>
        <el-table
            ref="multipleTable"
            :data="otherTable"
            stripe
            border
            max-height="500"
            style="width: 100%">
          <el-table-column
              type="index"
              label="#">
          </el-table-column>
          <el-table-column
              prop="id"
              :show-overflow-tooltip="true"
              label="预测编码">
          </el-table-column>
          <el-table-column
              prop="country"
              :show-overflow-tooltip="true"
              label="国家名称">
            <template slot-scope="scope">
              <dictname category="YLCountry_agent"  :v="scope.row.country"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="proModel"
              :show-overflow-tooltip="true"
              label="型号">
          </el-table-column>
          <el-table-column
              prop="proCode"
              :show-overflow-tooltip="true"
              label="产品编码">
          </el-table-column>
          <el-table-column
              prop="protype"
              label="型号属性"
              :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
              prop="proNumber"
              :show-overflow-tooltip="true"
              label="数量">
          </el-table-column>
          <el-table-column
              prop="useNumber"
              :show-overflow-tooltip="true"
              label="可用数量">
          </el-table-column>
          <el-table-column
              prop="useInventory"
              :show-overflow-tooltip="true"
              label="使用库存数量">
          </el-table-column>
          <el-table-column
              prop="stockStatus"
              label="库存状态">
            <template slot-scope="scope">
              <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="cuname"
              label="创建人">
          </el-table-column>
        </el-table>
      </div>
      <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
    <div class="h-table h-mrt30    bbbb" v-if="this.taskstatus == '0'">
      <div class="h-pieceTitle2 hang">
        <h1 class="h1">审批意见</h1>
        <el-form :model="spform" label-position="right" :inline="true"
                 class="demo-ruleForm h-formbLine ">
          <el-form-item label="上传附件" v-if="uploadFlag" class="h-elformWrap-2 " style="margin:30px 0 20px 23px" :required="true">
            <brupload
                :refid="order.id"
                reftype="服务订单审批附件"
                :limit="1"
                :showtime="false" uploadflag delflag
            >
            </brupload>
          </el-form-item>
          <el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:30px 0 20px 23px" :required="true">
            <el-input v-model="spform.shpyj" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="anniu" v-if="this.taskstatus == '0'">
      <el-button  @click="saveOrSubmit" class="el-button h-btn h-bBtn h-bgwhite el-button--default" >返回</el-button>
      <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="saveOrSubmit(2)">驳回</el-button>
      <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="saveOrSubmit(1)">通过</el-button>
      <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
    </div>
    <div class="anniu" v-if="this.taskstatus == '1'">
      <el-button  @click="saveOrSubmit" class="el-button h-btn h-bBtn h-bgwhite el-button--default" > 返回</el-button>
      <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
    </div>
  </div>
</template>

<script>
import big from 'big.js'
import ss from '../../api/SystemService'


export default {

  data() {
    return {
      uploadFlag:false,
      priceName:"基准价",
      showService:false,
      showIsFree:false,
      showIsFree6200:false,
      costList:[],
      instid:null,
      spform:{
        ywid:null,
        taskid:null,
        taskstatus:null,
        optflag:null,
        shpyj:null,
      },
      showFee:true,
      //单位
      dwzhiliang:null,
      dwtiji:null,
      showhistory:false,
      //特价展示
      tejieshowflag:false,
      //上传信用证
      shifouxinyzh:false,
      //是否定制
      dingzhishowflag:false,
      //是否展示收货地址
      isAddress:false,
      disabled:false,
      areaList:[],
      areaUserList:[],
      order:{
        businessUser:null,
        businessArea:null,
        sapCode:null,//订单号
        fktj:null,
        gjmytk:null,
        id:null, // 主键
        orderMainContract:null, // 主合同编号
        orderSubContract:null, // 分合同编号
        orderProjectCode:null, // 项目编号
        orderProjectName:null, // 项目名称
        orderCategory:null, // 订单类型
        orderCategory1:null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
        saleGroupCode:null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
        disChannelCode:null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
        zCode:null, // 分销渠道编码-子编码
        customerChannelCode:null, // 客户渠道
        isStockUp:null, // 是否备货      1：是；0：否
        orderStatus:null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
        instid:null, // 流程id
        tuihyy:null, // 退货原因
        tuihyydes:null, // 退货原因说明
        contactName:null, // 联系人名称
        receivedTime:null, // 预计收货时间
        soldToCode:null, // 售达方编码
        soldToName:null, // 售达方名称
        soldToAreaCode:null, // 售达方地区编码
        shipToCode:null, // 送达方编码
        shipToName:null, // 送达方名称
        shipToAreaCode:null, // 送达方地区编码
        invoiceCode:null, // 开票方编码
        payerCode:null, // 付款方编码
        currencyCode:null, // 币种编码
        orderPrice:null, // 订单总价
        orderPriceXj:null, // 订单现金占用
        creditid:null, // 信贷id
        orderPriceXd:null, // 订单信贷占用
        orderNetWorth:null, // 订单净价值
        poId:null, // PO号
        areaId:null, // 区域详情表关联id
        dcCode:null, // 配送中心编码
        toProvincesCode:null, // 送达省份编码
        toCityCode:null, // 送达城市编码
        note:null, // 订单备注
        postcode:null, // 邮政编码
        firsttelephone:null, // 第一个电话
        secondtelephone:null, // 第二电话
        extraPrice:null, // 定制加价
        customized:null, // 定制需求
        sapsended:null, // 是否已提交sap,1-是,0-否
        toAddress:null, // 收货地址
        toCompanyname:null, // 送达方公司全称
        posnr:null, // 外销:销售和分销凭证的项目号
        inco1:null, // 外销:国际贸易条款 (部分1)
        inco2:null, // 外销:国际贸易条款 (部分2)
        toCompany:null,

        categoryName:null,
        category1Name:null,
        saleGrputName:null,
        disChannelName:null,
        zcodeName:null,
        allNum:0,
        //汇总的毛净体
        allhjmaozh:0,
        allhjjinzh:0,
        allhjtiji:0,

        //汇总的佣金保费运费
        allfeeyongj:0,
        allfeebaof:0,
        allfeeyunf:0,

        boxing:null,
        boxNum:null,
        attachment:null
      },

      //产品list
      productlist1:[],

      //用户信贷list
      creditData:[],
      otherTable:[],
    }
  },
  //页面加载前事件
  created() {
    let id = this.$route.query.ywid || this.$route.query.id;
    let instid = this.$route.query.instid;
    let taskid = this.$route.query.taskid;
    let taskstatus = this.$route.query.taskstatus;

    this.instid = instid;
    this.taskstatus = taskstatus;
    this.spform.ywid = id;
    this.spform.taskid = taskid;
    this.getOrder(id);
  },
  beforeRouteLeave(to,from,next){
    if(to.path=='/dingd/orderProcess' && from.path == '/dingdmain/orderWxshenpi'){
      to.meta.keepAlive = true;
    }else{
      to.meta.keepAlive = false;
    }
    next();
  },
  computed:{
    xsqyStr() {
      this.disabled = false;
      if(this.order.category2Name){
        return this.order.categoryName +"/"+ this.order.category1Name +"/"+ this.order.category2Name
      }else if(this.order.category1Name){
        if(this.order.category1Name =='标准自产订单' || this.order.category1Name =='标准OEM订单' || this.order.category1Name =='国内外贸公司订单'){
          this.disabled = true;
        }
        return this.order.categoryName +"/"+ this.order.category1Name
      }
      return this.order.categoryName
    },
    xszzStr() {
      return "("+this.order.saleGroupCode+")"+this.order.saleGrputName;
    },
    fxqdStr() {
      if(this.order.zcodeName){
        return this.order.disChannelName +"/"+ this.order.zcodeName
      }
      return this.order.disChannelName
    },
    total() {
      return this.rows.map(
          row => row.purchaseCount * row.price).reduce(
          (acc, cur) => (parseFloat(cur) + acc), 0)
    }
  },
  // watch:{
  //     productlist1:{
  //         deep: true,
  //         handler(newValue, oldValue) {
  //             //毛净体合计
  //             this.order.allmaozhong = _.reduce(_.map(newValue,(o)=>{return new big(o.wlmaozh).times(o.proNumber||0)}),function (sum,v) {
  //                 return new big(sum).plus(v).toString();
  //             },0)
  //             this.order.alljinghzong = _.reduce(_.map(newValue,(o)=>{return new big(o.wljinzh).times(o.proNumber||0) }),function (sum,v) {
  //                 return new big(sum).plus(v).toString();
  //             },0)
  //             this.order.alltiji = _.reduce(_.map(newValue,(o)=>{return new big(o.wltiji).times(o.proNumber||0) }),function (sum,v) {
  //                 return new big(sum).plus(v).toString();
  //             },0)
  //
  //         },
  //     }
  // },
  watch:{
    productlist1:{
      deep: true,
      handler(newValue, oldValue) {
        //件数合计
        this.order.allNum = _.reduce(_.map(newValue,(o)=>{return new big(o.proNumber)}),function (sum,v) {
          return new big(sum).plus(v).toString();
        },0)
      },
    }
  },
  methods: {
    getOrder(id) {
      ss.OrderMainService.selectById(id).then(rd => {
        _.assign(this.order, rd.obj)
        console.log('我在这儿呀', this.order);
        this.ddlx = this.order.orderCategory+","+(this.order.orderCategory1||'');
        var type = this.order.orderCategory1||'';
        //付款条件
        if(this.order.fktj == "LC50" || this.order.fktj == "LCHY"){
          this.shifouxinyzh = true;
        }
        //    改制订单
        if (type == '22') {
          this.dingzhishowflag = true;
        } else if(type == '23') {
          //免费订单
          this.showIsFree = true;
          ss.OrderMainService.getCostCenterList({companyCode:this.order.saleGroupCode}).then(rd=>{
            this.costList = rd;
          })
        } else if(type == '25'){
          //服务订单
          this.showService = true;
          this.priceName = "销售单价";
          if (this.order.cucode == this._user.usercode) {
            this.uploadFlag = true;
          }
        }else if(type == '29') {
          //6200免费订单类型
          this.showIsFree6200 = true;
          ss.OrderMainService.getCostCenterList({companyCode:this.order.saleGroupCode}).then(rd=>{
            this.costList = rd;
          })
        }else if (type == '23' ||type == '24'){
          //oms订单免费订单oem订单
          var objs = this.order.products;
          for(var i=0;i<objs.length;i++){
            //判断是否需要填写收货地址
            //如果是oem标准订单,免费订单,产品是oem并且产地是6200发货方式为直发,收货地址必填
            if( objs[i].proType == 'OEM' && objs[i].zhifakufa == '1'){
              this.isAddress = true;
            }
          }
        }
        //存在行项目
        if (rd.obj.products && rd.obj.products.length > 0) {
          this.order.costCenter = rd.obj.products[0].costCenter;
          rd.obj.products.forEach((obj) => {
            if(!this.order.sapCode){
              this.order.sapCode=obj.sapCode;
            }
            this.addProject(obj);
          })
            this.getStockOther(rd.obj.products);
        }
        //当国际贸易条款为FOB和EXW时，去除产品信息列表保费、运费两列显示
        if (this.order.gjmytk == 'FOB' || this.order.gjmytk == 'EXW') {
          //console.log("条件进入？")
          this.showFee = false;
        } else {
          this.showFee = true;
        }
        this.order.businessUser = rd.obj.businessUser
        this.order.businessArea = rd.obj.businessArea
        this.getAreaList();
        this.getAreaUserList();
      })
    },
    addProject(obj){
      //    毛净体的单位
      if(this.dwzhiliang == null){
        this.dwzhiliang = obj.wlzhongldw||'KG';
        this.dwtiji = obj.wltijidw||'M3';
      }
      if(obj.specialOfferCode && !this.tejieshowflag){
        this.tejieshowflag = true;
      }
      // this.dingzhishowflag = true;
      if(!this.dingzhishowflag && obj.isCustommed == '1'){
        this.dingzhishowflag = true;
      }
      this.productlist1.push(obj);
      // //如果是定制单的话，获取定制的list
      // if(this.dingzhishowflag){
      //     // ss.OrderMainService.getselectedDingzhides({ids:obj.extraDes}).then(rd=>{
      //     //     console.log("获取到定制信息：",rd,obj)
      //     //     obj.extraDes = _.join(rd.obj,"<br>")
      //     //     this.productlist1.push(obj);
      //     // })
      // }else{
      //     this.productlist1.push(obj);
      // }
    },
    viewpress(r){
      this.showhistory = true;
    },
    backtolist() {
      this.$router.go(-1);
    },
    saveOrSubmit(v) {
      if (v == '2') {
        this.spform.optflag = '驳回'
        if(!this.spform.shpyj){
          this.$msg.msge("驳回必须输入审批意见！");
          return;
        }
      } else if (v == '1') {
        this.spform.optflag = '通过'
      } else {
        //点击详情进来的
        // if(this.$route.query.f == '1'){
        //     this.$router.push({path:'/dingd/dingdwxlist'})
        //     return;
        // }
        // this.$router.go(-1);
        //刷新右上角的代办个数
        this.$store.dispatch("searchTasktotal")
        //跳转回系统的代办列表
        //this.$router.push({path:'/personal/dealCenter'});
        this.$router.go(-1);
        return;
      }
      this.$msg.confirm("确认提交？", () => {
        this.submitForm();
      })
    },
    submitForm() {
      this.spform.orderMainProductList = this.productlist1;
      ss.OrderMainService.shpsaveOrSubmitUsa(this.spform).then(rd => {
        this.$msg.alerts("提交成功！",()=>{
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回原页面
          this.$router.go(-1);
          //this.$router.push({path: '/personal/dealCenter'});
        })
      })
    },
    //根据国家对应的区域
    getAreaList(){
      ss.OrderMainService.getAreaList(this.order.shipToAreaCode).then(rd=>{
        this.areaList = rd;
      })
    },
    //区域对应的人员
    getAreaUserList(){
      ss.OrderMainService.getAreaUserList(this.order.businessArea).then(rd=>{
        this.areaUserList = rd;
      })
    },

    //查询被占用的预测信息 hyl
    getStockOther(pList) {
        var ids =[];
        this.otherTable = [];
        console.log("占用预测信息：",pList)
        pList.forEach((obj)=>{
            if(obj.ycrcode == this.$store.getters.user.usercode){
                ids.push(obj.ycid);
            }
        })
        if(ids.length>0) {
            console.log("查询占用预测信息：", ids)
            ss.waixiao.selectByIds(ids).then(rd => {
                if (rd && rd.length > 0) {
                    this.otherTable = rd;
                }
            })
        }
    },
  }
}

</script>


<style scoped>
.queren {
  background-color: #006aca;
  color: white;
}
.anniu {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.jieguo {
  border-bottom: 1px solid rgb(238, 236, 236);
  display: flex;
}
.jieguo .jieguo_label{
  width: 2.5rem;
  text-align: right;
  background-color: #ebf5ff;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.12rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jieguo .jieguo_value{
  width: 20%;
  font-size: 0.16rem;
  color: #616467;
  padding: 0px 8px;
  height: 0.4rem;
  line-height: 0.4rem;
}
img {
  width: 25px;
  padding: 5px 0;
  margin-left: 8rem;
}

.newProject {
  margin: 0 20px;
  background-color: rgb(94, 182, 233);
}

/* .h-crumbOut {
    margin-bottom: 20px;
} */

.h-piece {
  margin: 20px;
}
.h1 {
  margin-left: 27px;
}
.message {
  padding: 20px 0;
  margin-bottom: 0;
  background-color: white;
}
.n-xiao .h-formbLine .h-elformWrap-2,
.n-two .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}
</style>
<style>
.n-two .h-formbLine .el-form-item__content .el-select,
.n-two .el-form .h-formbLine .el-form-item__content .el-select {
  width: 0;
}
.n-xiao .h-formbLine .el-form-item__label,
.n-two .h-formbLine .el-form-item__label {
  width: 43%;
}

.n-xiao .h-formbLine .el-form-item__content,
.n-two .h-formbLine .el-form-item__content {
  width: 57%;
}

.bbbb {
  padding-top: 5px;
  margin: 0 20px;
}
.hang {
  padding: 20px 0;
  margin-bottom: 0;
  background-color: white;
}
.ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
  color: #868686;
}
</style>

